import { render, staticRenderFns } from "./HeadlineTitleList.vue?vue&type=template&id=62243ea0&scoped=true"
import script from "./HeadlineTitleList.vue?vue&type=script&lang=ts"
export * from "./HeadlineTitleList.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineTitleList.vue?vue&type=style&index=0&id=62243ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62243ea0",
  null
  
)

export default component.exports